import React from 'react';
import queryString from 'query-string';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { gqlConfirmSignupEmail } from 'shared/gql/auth';
import { compose } from 'shared/helpers';
import { WELCOME_INTRO_ACCOUNT_TYPE } from 'shared/constants/web';
import { decodeJwt } from 'shared/helpers/jwtStore';
import { userDidLogin } from 'shared/actions/session';

import { HorizontalRule, Link, TwoColumnInfoTable } from 'components/elems';
import { InitialLoading, GenericError } from 'pages';



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    userDidLogin,
  }, dispatch);
}


const ConfirmSignupEmailErrorPage = () => (
  <GenericError
    headline="Sorry, this confirmation link is either invalid or has expired."
  >
    <div className="mt5">
      <HorizontalRule align="left" thickness="2px" width="4rem" />
      <TwoColumnInfoTable
        className="mv3"
        rows={[
          [
            <span>What Now?</span>,
            <span>
              Try <Link type="accented" to="/login">logging in</Link> to
              your account, you might have already confirmed
              your email. If not, we will send you a new one then as needed.
            </span>
          ],
        ]}
      />
    </div>
  </GenericError>
);


/*
 * ConfirmSignupEmail
 */
class ConfirmSignupEmail extends React.Component {

  componentWillReceiveProps(nextProps) {
    const { data = {} } = nextProps;
    const { jwt } = data.signupEmailConfirmation || {};

    if (jwt) {
      // Succesfully confirmed email, dispatch to store jwt and update redux.
      nextProps.userDidLogin({ jwt });
    }
  }

  render() {
    const { data = {} } = this.props;
    if (data.loading) {
      return (
        <InitialLoading
          showNavbarOnUnmount={true}
          showFooterOnUnmount={false}
        />
      );
    }

    const [
      {name: {value: fieldName}},
    ] = gqlConfirmSignupEmail.definitions;

    const { errors, jwt } = data[fieldName];
    if (errors.length) {
      return <ConfirmSignupEmailErrorPage />;
    }

    const { sub: handle } = decodeJwt(jwt);

    return (
      <Redirect
        to={{
          pathname: '/welcome',
          state: {
            viewStack: [WELCOME_INTRO_ACCOUNT_TYPE],
            handle,
          },
        }}
      />
    );
  }
}


export default compose(
  connect(null, mapDispatchToProps),
  graphql(gqlConfirmSignupEmail, {
    options: ({location}) => {
      const { token, sig } = queryString.parse(location.search);
      const variables = { token, sig };
      return { variables };
    },
  }),
)(ConfirmSignupEmail);



// WEBPACK FOOTER //
// ./src/pages/a/confirm/ConfirmSignupEmail.js